<template>
  <div class="w-full h-full">
    <div class="bg-[#F9F9F9] fixed w-screen h-screen -z-50" />

    <div class="py-12 px-8 flex flex-col lg:flex-row gap-[20px] w-full">
      <!--      <DomainNav :verified="verify || awsConnected" />-->
      
      <keep-alive>
        <router-view />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
// import DomainNav from '@/views/domain/DomainNav.vue'
export default {
  name: 'DomainLayout',
  // components: {DomainNav},
  data () {
    return {
      verify: false
    }
  },
  computed: {
    ...mapState('projects', {
      project: state => state.project
    }),
    awsConnected () {
      return !!this.project.aws_data?.tenant_id
    }
  },
  methods: {
    ...mapActions({
      checkNS: 'domain/checkNS'
    }),
    async checkDomain () {
      if (!this.project.domain || this.awsConnected) {
        this.loading = false
        return false
      }

      await this.checkNS()
        .then(async (data) => {
          this.verify = data.valid
        })
    }
  },
  async mounted () {
    await this.checkDomain()
  }
}
</script>